// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, no-unused-vars
// Helper function to check if a value is numeric
const isNumeric = (val: string) => {
  return !isNaN(Number(val)) && !isNaN(parseFloat(val))
}

export function evaluateCondition(obj: any, conditionStr: string) {
  try {
    // obj is used in the dynamically generated eval expression below
    // Ensure obj is not undefined before proceeding
    if (obj === undefined) obj = {}

    // Regex untuk mencocokkan properti objek dengan nilai string (mendukung underscore, hyphen, dan operator == atau !=)
    // Perbaikan: gunakan [a-zA-Z0-9_-] untuk menangkap semua karakter yang valid dalam property name
    // Mendukung operator == dan != serta logical operator && dan ||
    const jsExpression = conditionStr.replace(
      /([a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*)\s*(==|!=|>=|<=|>|<)\s*(".*?"|'.*?'|null|undefined|true|false|\d{4}-\d{2}-\d{2}|[a-zA-Z0-9_]+)/g,
      (_match, key, operator, val) => {
        // Handle special values (null, undefined, true, false) - don't add quotes
        const isSpecialValue = ['null', 'undefined', 'true', 'false'].includes(val.toLowerCase())

        // Handle date format (YYYY-MM-DD) - wrap in quotes for string comparison
        const isDateValue = /^\d{4}-\d{2}-\d{2}$/.test(val)

        // Check if value is numeric (for proper numeric comparison)
        const isNumericValue =
          !isSpecialValue && !isDateValue && !val.startsWith('"') && !val.startsWith("'") && isNumeric(val)

        // Bersihkan tanda kutip dari val jika ada (kecuali untuk special values dan dates)
        const cleanVal = isSpecialValue ? val.toLowerCase() : isDateValue ? val : val.replace(/^['"]|['"]$/g, '')

        // Handle property names - gunakan bracket notation hanya untuk property yang mengandung hyphen
        const objAccess = key.split('.').reduce((acc: string, curr: string) => {
          if (curr.includes('-')) {
            // Gunakan bracket notation untuk property dengan hyphen
            return acc === 'obj' ? `obj["${curr}"]` : `${acc}["${curr}"]`
          } else {
            // Gunakan dot notation untuk property normal (dengan underscore tetap bisa)
            return acc === 'obj' ? `obj?.${curr}` : `${acc}?.${curr}`
          }
        }, 'obj')

        // Return with or without quotes based on value type
        if (isSpecialValue) {
          // For == and !=, check array inclusion, otherwise use regular comparison
          if (operator === '==') {
            return `(Array.isArray(${objAccess}) ? ${objAccess}.includes(${cleanVal}) : ${objAccess} ${operator} ${cleanVal})`
          } else if (operator === '!=') {
            return `(Array.isArray(${objAccess}) ? !${objAccess}.includes(${cleanVal}) : ${objAccess} ${operator} ${cleanVal})`
          } else {
            return `${objAccess} ${operator} ${cleanVal}`
          }
        } else if (isDateValue) {
          // For date comparisons, wrap both sides in quotes for string comparison
          if (operator === '==') {
            return `(Array.isArray(${objAccess}) ? ${objAccess}.includes("${cleanVal}") : ${objAccess} ${operator} "${cleanVal}")`
          } else if (operator === '!=') {
            return `(Array.isArray(${objAccess}) ? !${objAccess}.includes("${cleanVal}") : ${objAccess} ${operator} "${cleanVal}")`
          } else {
            return `${objAccess} ${operator} "${cleanVal}"`
          }
        } else if (isNumericValue) {
          // For numeric comparisons, convert both sides to numbers
          if (operator === '==') {
            return `(Array.isArray(${objAccess}) ? ${objAccess}.includes(${cleanVal}) : Number(${objAccess}) ${operator} Number(${cleanVal}))`
          } else if (operator === '!=') {
            return `(Array.isArray(${objAccess}) ? !${objAccess}.includes(${cleanVal}) : Number(${objAccess}) ${operator} Number(${cleanVal}))`
          } else {
            return `Number(${objAccess}) ${operator} Number(${cleanVal})`
          }
        } else {
          if (operator === '==') {
            return `(Array.isArray(${objAccess}) ? ${objAccess}.includes("${cleanVal}") : ${objAccess} ${operator} "${cleanVal}")`
          } else if (operator === '!=') {
            return `(Array.isArray(${objAccess}) ? !${objAccess}.includes("${cleanVal}") : ${objAccess} ${operator} "${cleanVal}")`
          } else {
            return `${objAccess} ${operator} "${cleanVal}"`
          }
        }
      }
    )

    return eval(jsExpression)
  } catch (error) {
    console.error('Error evaluating condition:', error)
    console.error('Original condition:', conditionStr)
    return false
  }
}
